import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "form", "memberName"]

  open(event) {
    event.preventDefault()
    const name = event.currentTarget.dataset.memberName
    const membershipId = event.currentTarget.dataset.membershipId

    this.memberNameTarget.textContent = name
    this.formTarget.action = this.formTarget.dataset.baseUrl.replace(
      "__MEMBERSHIP_ID__",
      membershipId,
    )

    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  confirm() {
    this.formTarget.addEventListener(
      "turbo:submit-end",
      (event) => {
        if (event.detail.success) {
          this.close()
        }
      },
      { once: true },
    )
    this.formTarget.requestSubmit()
  }

  // Close on backdrop click
  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  // Close on Escape key
  keydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
